export default __webpack_public_path__ + "static/media/certificate1.7a06648d.jpg";